import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  customIconButton: {
    color: theme.palette.layout.textPrimary,
    padding: theme.spacing(1),
    '&:hover': {
      color: theme.palette.layout.secondary,
      backgroundColor: theme.palette.layout.textPrimary,
    },
  },

  standardIconButton: {
    color: palette.dai.shinyBlue,
    padding: theme.spacing(1),
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: palette.dai.shinyBlue,
    },
  },

  customIconButtonActive: {
    color: theme.palette.layout.secondary,
    backgroundColor: theme.palette.layout.textPrimary,
  },

  standardIconButtonActive: {
    color: theme.palette.primary.main,
    backgroundColor: palette.dai.shinyBlue,
  },
}))

export default styles
